import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=53e597d2"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=53e597d2&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e597d2')) {
      api.createRecord('53e597d2', component.options)
    } else {
      api.reload('53e597d2', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=53e597d2", function () {
      api.rerender('53e597d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DataTable.vue"
export default component.exports